__webpack_require__.p = "https://static.age.awaze.com/search-mfe/f42c418/_next/";